export enum UploadState {
    InProgress,
    Finished,
    Failed,
}
